export default __webpack_public_path__ + "static/LastClassFranz-b5e08afa4e02e403ee844468788c2950.png";